var service = function(C) {
  this.getUrl = function(image_path, transform) {
    var host = C.CLOUDINARY.host;
    var bucket = C.CLOUDINARY.bucket;

    return `//${host}/${bucket}/image/upload/${transform}/${image_path}`
  }
};

service.$inject = ['C'];

tiz.service('Cloudinary', service);
